import React, { useState } from 'react';
import Nav from '../Nav/Nav';

const categories = [
  { icon: '👑', label: 'Luxury Escapes' },
  { icon: '👨‍👩‍👧‍👦', label: 'Family Holidays' },
  { icon: '💑', label: 'Honeymoon' },
  { icon: '🏔', label: 'Adventure' },
  { icon: '🏖', label: 'Beach Holidays' },
  { icon: '🏛', label: 'Cultural Journeys' },
  { icon: '🧘', label: 'Wellness' },
  { icon: '🌄', label: 'Weekend Getaways' },
];

const packages = [
  {
    name: 'Royal Rajasthan Escape',
    destinations: 'Delhi · Agra · Jaipur · Udaipur',
    duration: '6N / 7D',
    price: '₹85,000',
    unit: 'per couple',
    img: 'https://images.unsplash.com/photo-1695956353120-54ce5e91632b?w=600&h=380&fit=crop&auto=format',
    tag: 'Best Seller',
    tagColor: 'var(--gold, #C9A45C)',
    includes: ['Premium Hotels', 'Private Transfers', 'Breakfast', 'Sightseeing'],
  },
  {
    name: 'Kashmir Serenity',
    destinations: 'Srinagar · Gulmarg · Pahalgam',
    duration: '5N / 6D',
    price: '₹65,000',
    unit: 'per couple',
    img: 'https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?w=600&h=380&fit=crop&auto=format',
    tag: 'Luxury',
    tagColor: 'var(--royal, #0D233A)',
    includes: ['Luxury Houseboats', 'Shikara Rides', 'All Meals', 'Transfers'],
  },
  {
    name: 'Kerala Backwaters & Beyond',
    destinations: 'Munnar · Thekkady · Alleppey · Kovalam',
    duration: '4N / 5D',
    price: '₹48,000',
    unit: 'per couple',
    img: 'https://images.unsplash.com/photo-1506461883276-594a12b11cf3?w=600&h=380&fit=crop&auto=format',
    tag: 'Trending',
    tagColor: 'var(--success, #16865B)',
    includes: ['Houseboat Stay', 'Ayurvedic Spa', 'Breakfast', 'Sightseeing'],
  },
  {
    name: 'Goa Beach Getaway',
    destinations: 'North Goa · South Goa',
    duration: '3N / 4D',
    price: '₹28,000',
    unit: 'per couple',
    img: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=600&h=380&fit=crop&auto=format',
    tag: 'Weekend',
    tagColor: 'var(--text-secondary, #718096)',
    includes: ['Beach Resort', 'Water Sports', 'Breakfast', 'Airport Transfers'],
  },
];

const rajasthanItinerary = [
  { day: 1, title: 'Delhi Arrival', desc: 'Welcome at IGI Airport. Transfer to hotel. Evening Delhi walk and dinner.' },
  { day: 2, title: 'Delhi Sightseeing', desc: "Humayun's Tomb, Qutub Minar, Lotus Temple, India Gate. Farewell Delhi dinner." },
  { day: 3, title: 'Agra — Taj Mahal', desc: 'Morning drive to Agra. Sunrise Taj Mahal visit. Agra Fort. Drive to Jaipur.' },
  { day: 4, title: 'Jaipur — Pink City', desc: 'Amber Fort, City Palace, Hawa Mahal, Jantar Mantar. Rajasthani cultural dinner.' },
  { day: 5, title: 'Jaipur Experiences', desc: 'Hot air balloon at dawn. Elephant polo, local bazaar, cooking class.' },
  { day: 6, title: 'Udaipur — City of Lakes', desc: 'Drive to Udaipur. Lake Pichola boat ride. City Palace. Sunset dinner.' },
  { day: 7, title: 'Departure', desc: 'Farewell breakfast. Transfer to Udaipur airport. Your royal journey concludes.' },
];

export default function Tours() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [showPackage, setShowPackage] = useState(false);

  const btnGoldStyle = {
    background: 'var(--gold, #C9A45C)',
    color: 'var(--navy, #071A2B)',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Manrope, sans-serif',
  };

  const btnOutlineStyle = {
    background: 'transparent',
    border: '1.5px solid var(--border, rgba(7, 26, 43, 0.15))',
    color: 'var(--navy, #071A2B)',
    cursor: 'pointer',
    fontFamily: 'Manrope, sans-serif',
  };

  const sectionLabelStyle = {
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    fontSize: '12px',
    fontWeight: 700,
    color: 'var(--gold, #C9A45C)',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
    <Nav/>
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg, #F8FAFC)',
        fontFamily: 'Manrope, sans-serif',
        color: 'var(--navy, #071A2B)',
      }}
    >
      {/* Hero */}
      <div
        style={{
          position: 'relative',
          paddingTop: '80px',
          paddingBottom: '48px',
          background: 'var(--navy, #071A2B)',
          overflow: 'hidden',
        }}
      >
        <img
          src="https://images.unsplash.com/photo-1661174607003-d9d36388c916?w=1400&h=400&fit=crop&auto=format"
          alt="Kerala backwaters"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.35,
          }}
        />
        <div
          style={{
            position: 'relative',
            zIndex: 10,
            maxWidth: '1280px',
            margin: '0 auto',
            padding: '32px 24px',
            textAlign: 'center',
            boxSizing: 'border-box',
          }}
        >
          <p style={{ ...sectionLabelStyle, marginBottom: '12px' }}>Tours & Holidays</p>
          <h1
            style={{
              fontSize: 'clamp(2.5rem, 5vw, 3rem)',
              fontWeight: 800,
              color: '#ffffff',
              marginBottom: '16px',
              lineHeight: 1.1,
              fontFamily: 'Manrope, sans-serif',
              margin: '0 0 16px 0',
            }}
          >
            Discover India Your Way.
          </h1>
          <p
            style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '16px',
              maxWidth: '576px',
              margin: '0 auto',
              lineHeight: 1.6,
            }}
          >
            Curated journeys, unforgettable experiences and stays designed around you.
          </p>
        </div>
      </div>

      {/* Categories */}
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '32px 24px',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '12px',
            overflowX: 'auto',
            paddingBottom: '8px',
            scrollbarWidth: 'none',
          }}
        >
          {categories.map((cat, i) => (
            <button
              key={cat.label}
              type="button"
              onClick={() => setActiveCategory(i)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                borderRadius: '9999px',
                fontSize: '13px',
                fontWeight: 600,
                flexShrink: 0,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                background: activeCategory === i ? 'var(--navy, #071A2B)' : '#ffffff',
                color: activeCategory === i ? '#ffffff' : 'var(--text-secondary, #4A5568)',
                border: `1px solid ${activeCategory === i ? 'var(--navy, #071A2B)' : 'var(--border, rgba(7, 26, 43, 0.08))'}`,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              <span>{cat.icon}</span>
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Packages Grid */}
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 24px 64px 24px',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '24px',
            marginBottom: '48px',
          }}
        >
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              onClick={() => setShowPackage(true)}
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                cursor: 'pointer',
                background: 'var(--white, #ffffff)',
                border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ position: 'relative', height: '224px', backgroundColor: '#E2E8F0' }}>
                <img
                  src={pkg.img}
                  alt={pkg.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(to top, rgba(7, 26, 43, 0.6) 0%, transparent 50%)',
                  }}
                />
                <div style={{ position: 'absolute', top: '12px', left: '12px' }}>
                  <span
                    style={{
                      padding: '4px 10px',
                      borderRadius: '9999px',
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#ffffff',
                      background: pkg.tagColor,
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {pkg.tag}
                  </span>
                </div>
                <div style={{ position: 'absolute', bottom: '12px', left: '16px' }}>
                  <p
                    style={{
                      color: '#ffffff',
                      fontWeight: 700,
                      fontSize: '11px',
                      opacity: 0.8,
                      margin: 0,
                    }}
                  >
                    {pkg.destinations}
                  </p>
                </div>
              </div>
              <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      marginBottom: '12px',
                    }}
                  >
                    <div>
                      <h3
                        style={{
                          fontWeight: 800,
                          fontSize: '16px',
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #071A2B)',
                          margin: 0,
                        }}
                      >
                        {pkg.name}
                      </h3>
                      <p
                        style={{
                          fontSize: '12px',
                          marginTop: '2px',
                          color: 'var(--text-muted, #718096)',
                          margin: '2px 0 0 0',
                        }}
                      >
                        {pkg.duration}
                      </p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <p
                        style={{
                          fontSize: '20px',
                          fontWeight: 800,
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #071A2B)',
                          margin: 0,
                        }}
                      >
                        {pkg.price}
                      </p>
                      <p
                        style={{
                          fontSize: '11px',
                          color: 'var(--text-muted, #718096)',
                          margin: 0,
                        }}
                      >
                        {pkg.unit}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '6px',
                      marginBottom: '16px',
                    }}
                  >
                    {pkg.includes.map((inc) => (
                      <span
                        key={inc}
                        style={{
                          fontSize: '11px',
                          padding: '4px 10px',
                          borderRadius: '9999px',
                          background: 'var(--bg, #F8FAFC)',
                          border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                          color: 'var(--text-secondary, #4A5568)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        ✓ {inc}
                      </span>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    type="button"
                    onClick={() => setShowPackage(true)}
                    style={{
                      ...btnGoldStyle,
                      flex: 1,
                      padding: '10px 0',
                      borderRadius: '8px',
                      fontSize: '13px',
                    }}
                  >
                    Explore Journey
                  </button>
                  <button
                    type="button"
                    style={{
                      ...btnOutlineStyle,
                      padding: '10px 16px',
                      borderRadius: '8px',
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    Customize
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Package Detail Modal */}
        {showPackage && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px',
              background: 'rgba(7, 26, 43, 0.8)',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '768px',
                maxHeight: '90vh',
                overflowY: 'auto',
                borderRadius: '16px',
                background: 'var(--white, #ffffff)',
                position: 'relative',
              }}
            >
              <div style={{ position: 'relative', height: '224px', backgroundColor: '#E2E8F0' }}>
                <img
                  src="https://images.unsplash.com/photo-1695956353120-54ce5e91632b?w=800&h=300&fit=crop&auto=format"
                  alt="Rajasthan"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(to top, rgba(7, 26, 43, 0.7) 0%, transparent 50%)',
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPackage(false)}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff',
                    fontSize: '18px',
                    fontWeight: 700,
                    background: 'rgba(7, 26, 43, 0.6)',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  ×
                </button>
                <div style={{ position: 'absolute', bottom: '16px', left: '20px' }}>
                  <h2
                    style={{
                      fontSize: '24px',
                      fontWeight: 800,
                      color: '#ffffff',
                      fontFamily: 'Manrope, sans-serif',
                      margin: 0,
                    }}
                  >
                    Royal Rajasthan Escape
                  </h2>
                  <p
                    style={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontSize: '13px',
                      margin: '4px 0 0 0',
                    }}
                  >
                    6 Nights / 7 Days · Delhi · Agra · Jaipur · Udaipur
                  </p>
                </div>
              </div>

              <div style={{ padding: '24px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '20px',
                    paddingBottom: '16px',
                    borderBottom: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                    gap: '12px',
                  }}
                >
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {['Premium Hotels', 'Private Transfers', 'Breakfast', 'Sightseeing', 'Travel Assistance'].map((inc) => (
                      <span
                        key={inc}
                        style={{
                          fontSize: '11px',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          background: 'var(--bg, #F8FAFC)',
                          color: 'var(--text-secondary, #4A5568)',
                          border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                        }}
                      >
                        ✓ {inc}
                      </span>
                    ))}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p
                      style={{
                        fontSize: '24px',
                        fontWeight: 800,
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                        margin: 0,
                      }}
                    >
                      From ₹85,000
                    </p>
                    <p style={{ fontSize: '12px', color: 'var(--text-muted, #718096)', margin: 0 }}>
                      per couple
                    </p>
                  </div>
                </div>

                <h3
                  style={{
                    fontWeight: 700,
                    fontSize: '15px',
                    marginBottom: '16px',
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #071A2B)',
                    margin: '0 0 16px 0',
                  }}
                >
                  Day-by-Day Itinerary
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {rajasthanItinerary.map((day) => (
                    <div key={day.day} style={{ display: 'flex', gap: '16px' }}>
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '12px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          fontSize: '10px',
                          fontWeight: 700,
                          background: 'var(--navy, #071A2B)',
                          color: 'var(--gold, #C9A45C)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        <span>Day</span>
                        <span style={{ fontSize: '14px' }}>{day.day}</span>
                      </div>
                      <div style={{ flex: 1, paddingTop: '4px' }}>
                        <p
                          style={{
                            fontWeight: 600,
                            fontSize: '14px',
                            fontFamily: 'Manrope, sans-serif',
                            color: 'var(--navy, #071A2B)',
                            margin: 0,
                          }}
                        >
                          {day.title}
                        </p>
                        <p
                          style={{
                            fontSize: '12px',
                            marginTop: '2px',
                            color: 'var(--text-secondary, #4A5568)',
                            margin: '2px 0 0 0',
                          }}
                        >
                          {day.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    type="button"
                    style={{
                      ...btnGoldStyle,
                      flex: 1,
                      padding: '12px 0',
                      borderRadius: '12px',
                      fontSize: '14px',
                    }}
                  >
                    Request This Journey
                  </button>
                  <button
                    type="button"
                    style={{
                      ...btnOutlineStyle,
                      padding: '12px 20px',
                      borderRadius: '12px',
                      fontSize: '14px',
                      fontWeight: 700,
                    }}
                  >
                    Customize My Trip
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Custom Holiday Planner */}
        <div
          style={{
            borderRadius: '16px',
            padding: '32px',
            background: 'var(--navy, #071A2B)',
            border: '1px solid rgba(201, 164, 92, 0.2)',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '32px',
              alignItems: 'center',
            }}
          >
            <div>
              <p style={{ ...sectionLabelStyle, marginBottom: '12px' }}>Custom Planner</p>
              <h3
                style={{
                  fontSize: '30px',
                  fontWeight: 800,
                  color: '#ffffff',
                  marginBottom: '12px',
                  fontFamily: 'Manrope, sans-serif',
                  margin: '0 0 12px 0',
                }}
              >
                Tell Us Where You Want To Go.
              </h3>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.6)',
                  fontSize: '14px',
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                Can't find your perfect package? Let our experts create a bespoke itinerary just for you.
              </p>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: '12px',
              }}
            >
              {[
                { label: 'Destination', type: 'select', options: ['Kashmir', 'Kerala', 'Rajasthan', 'Goa'] },
                { label: 'Travel Style', type: 'select', options: ['Luxury', 'Premium', 'Family', 'Adventure'] },
                { label: 'Travel Date', type: 'date' },
                { label: 'Travellers', type: 'select', options: ['2 Adults', '1 Adult', '2 Adults + Children', 'Group'] },
              ].map((field) => (
                <div key={field.label}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '11px',
                      fontWeight: 600,
                      marginBottom: '4px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: 'rgba(255, 255, 255, 0.4)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {field.label}
                  </label>
                  {field.type === 'select' ? (
                    <select
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        fontSize: '13px',
                        outline: 'none',
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        color: '#ffffff',
                        boxSizing: 'border-box',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      {field.options?.map((o) => (
                        <option key={o} style={{ color: '#000000' }}>
                          {o}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={field.type}
                      defaultValue="2026-10-15"
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        fontSize: '13px',
                        outline: 'none',
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        color: '#ffffff',
                        boxSizing: 'border-box',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    />
                  )}
                </div>
              ))}
              <div style={{ gridColumn: 'span 2' }}>
                <button
                  type="button"
                  style={{
                    ...btnGoldStyle,
                    width: '100%',
                    padding: '12px 0',
                    borderRadius: '12px',
                    fontSize: '14px',
                  }}
                >
                  Plan My Holiday
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </>
  );
}